import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './UserProfile.css';

export const UserProfile = ({ user, size = 38, className = "" }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div 
      className="user-profile-wrapper"
      onMouseEnter={() => setIsDropdownVisible(true)}
      onMouseLeave={() => setIsDropdownVisible(false)}
    >
      <div 
        className={`user-profile-container ${className}`}
        style={{ width: size, height: size }}
      >
        {user?.photoURL ? (
          <img src={user.photoURL} alt="Profile" className="nav-profile-img" />
        ) : (
          <div className="nav-user-icon">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width={size * 0.52} 
              height={size * 0.52} 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
        )}
      </div>

      {isDropdownVisible && (
        <div className="profile-dropdown">
          <Link to="/profile" className="dropdown-item">View Profile</Link>
          <Link to="/profile" className="dropdown-item">My Bookings</Link>
          <Link to="/help" className="dropdown-item">Help</Link>
          <div className="dropdown-divider"></div>
          <button onClick={handleLogout} className="dropdown-item logout-btn">Logout</button>
        </div>
      )}
    </div>
  );
};
